import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { Container, Card } from "react-bootstrap";
import {
  Row,
  Col,
  DatePicker,
  Space,
  InputNumber,
  Input,
  Divider,
  Comment,
  Avatar,
  Form,
  message,
  Modal,
  Breadcrumb,
} from "antd";

import Slider from "react-slick";
import Button from "antd-button-color";
import ImageGallery from "react-image-gallery";

import { formatNumber } from "lib/utility";
import { productLists } from "data/product";
import { otherProductSettings } from "lib/slick";
import {
  renderLeftNav,
  renderRightNav,
  renderFullscreenButton,
} from "components/Products/Detail/ImageGalleryButton";

import CardProduct from "components/Card/Product";
import CommentContainer from "components/Comment";
import CardShare from "components/Card/ShareModal";

import "./style.css";

const getImageList = () => {
  const list = [];
  productLists.map((obj) => {
    const imgUrl = `/assets/img/products/${obj.image}`;
    return list.push({
      original: imgUrl,
      thumbnail: imgUrl,
      thumbnailClass: "thumbnail-product-image",
    });
  });
  return list;
};

const MESSAGE = "MESSAGE";
const REPLY = "REPLY";

const DetailPproduct = () => {
  const [showShare, setShowShare] = useState(false);
  const [showDelivery, setShowDelivery] = useState(false);

  return (
    <Container className="pt-4 pb-2">
      <Row gutter={[40, 20]}>
        <Col span={24}>
          <Breadcrumb className="text-truncate">
            <Breadcrumb.Item href="/products" className="text-decoration-none">
              Katalog
            </Breadcrumb.Item>
            <Breadcrumb.Item>Kursi</Breadcrumb.Item>
            <Breadcrumb.Item>Baju Kaos Atsn Bordir Lks</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col xxl={8} xl={8} lg={8} md={24} sm={24} xs={24}>
          <ImageGallery
            items={getImageList()}
            showPlayButton={false}
            useTranslate3D={false}
            useBrowserFullscreen={false}
            showFullscreenButton={false}
            renderLeftNav={renderLeftNav}
            renderRightNav={renderRightNav}
            renderFullscreenButton={renderFullscreenButton}
            additionalClass="product-images-container sticky-item-product"
          />
        </Col>
        <Col xxl={9} xl={9} lg={8} md={24} sm={24} xs={24}>
          <h4 className="font-weight-bold">
            Torino wooden chair with yacht leather cover platinum grey
          </h4>

          <Space>
            <span className="text-dark">
              <i className="far fa-eye me-1" /> Dilihat <span className="fw-500">8.321</span>
            </span>
            <span>•</span>
            <span className="text-dark">
              Tersewakan <span className="fw-500">2.301</span>
            </span>
          </Space>

          <h3 className="fw-600 mt-2">Rp 300.000</h3>

          <hr />

          <div>
            <div data-testid="lblPDPDescriptionProduk">
              F-010107
              <br />
              Baju Kaos Atsn Bordir Lks
              <br />
              Oleh Oleh Khas Bali
              <br />
              <br />
              Bahan : Kain rayon tipis
              <br /> Ukuran : All Size ( Lebar Dada 56 cm, Panjang 68 cm, Berat 88 gr)
              <br />
              ======================================
              <br />
              <br />
              Note : <br />
              1. Untuk pemesanan silahkan cantumkan pada note / keterangan warna &amp; ukuran yang
              diinginkan ( jika tidak ada keterangan warna &amp; ukuran yang diinginkan akan dikirim
              random sesuai stok yang ready )<br />
              2. Ukuran Lebar &amp; Panjang relative, tidak pasti harus sama antar produk
              <br />
              3. Pilihan hanya untuk warna, untuk motif bunga berbeda-beda tergantung produksi
              <br />
              <br />
              F-010107
              <br />
              Baju Kaos Atsn Bordir Lks
              <br />
              Oleh Oleh Khas Bali
              <br />
              <br />
              Bahan : Kain rayon tipis
              <br /> Ukuran : All Size ( Lebar Dada 56 cm, Panjang 68 cm, Berat 88 gr)
              <br />
              ======================================
              <br />
              <br />
              Note : <br />
              1. Untuk pemesanan silahkan cantumkan pada note / keterangan warna &amp; ukuran yang
              diinginkan ( jika tidak ada keterangan warna &amp; ukuran yang diinginkan akan dikirim
              random sesuai stok yang ready )<br />
              2. Ukuran Lebar &amp; Panjang relative, tidak pasti harus sama antar produk
              <br />
              3. Pilihan hanya untuk warna, untuk motif bunga berbeda-beda tergantung produksi
            </div>
          </div>
        </Col>

        <Col xxl={7} xl={7} lg={8} md={24} sm={24} xs={24}>
          <div className="sticky-item-product">
            <Card className="border-0 shadow border-radius-base mb-3">
              <Card.Body>
                <div className="mb-3">
                  <h6>Tanggal Sewa</h6>
                  <DatePicker.RangePicker format="DD/MM/YYYY" className="w-100" />
                </div>

                <div className="mb-3">
                  <h6>Jumlah</h6>
                  <div className="d-block w-100">
                    <Button
                      ghost
                      type="dark"
                      shape="circle"
                      icon={<i className="far fa-minus fs-11 va-2px" />}
                    />
                    <InputNumber
                      className="m-l-5 m-r-5 va-middle"
                      defaultValue={1}
                      max={230}
                      min={1}
                    />
                    <Button
                      ghost
                      type="dark"
                      shape="circle"
                      icon={<i className="far fa-plus fs-11 va-2px" />}
                    />
                  </div>
                  <small className="text-muted">
                    Tersedia <span className="fw-600 text-dark">230</span>
                  </small>
                </div>

                <div className="mb-3">
                  <h6>Catatan</h6>
                  <Input.TextArea />
                </div>

                <div className="mb-3">
                  <Button
                    type="link"
                    className="hover-pointer text-reset p-0"
                    onClick={() => setShowDelivery(true)}
                  >
                    <h6>Info Pengiriman</h6>
                  </Button>
                </div>

                <div className="mb-0">
                  <Row gutter={[16, 16]}>
                    <Col span={11}>
                      <Button type="text" block>
                        <i className="fas fa-heart me-2" /> Favorit
                      </Button>
                    </Col>
                    <Col span={2}>
                      <Divider type="vertical" className="h-100" />
                    </Col>
                    <Col span={11}>
                      <Button type="text" block onClick={() => setShowShare(true)}>
                        <i className="fas fa-share-alt me-2" /> Bagikan
                      </Button>
                    </Col>
                  </Row>
                </div>
              </Card.Body>
            </Card>

            <Row gutter={[16, 5]} className="mt-4">
              <Col span={12}>
                <Button ghost block type="success" size="large">
                  <i className="fab fa-whatsapp fa-lg me-2" /> Chat
                </Button>
              </Col>
              <Col span={12}>
                <Button
                  block
                  size="large"
                  type="dark"
                  onClick={() => message.success("Berhasil memasukkan ke keranjang")}
                >
                  <i className="far fa-cart-plus me-2" /> Keranjang
                </Button>
              </Col>
              <Col span={24} className="text-center">
                <small className="text-muted">Chat untuk informasi lebih lanjut</small>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>

      <hr className="mt-5 mb-4" />

      <h4>Komentar</h4>

      <section className="mb-0">
        <Comment
          avatar={
            <Avatar src={`https://i.pravatar.cc/100?u=${Math.random()}`} alt="Okky Suardhana" />
          }
          content={
            <Form>
              <Form.Item className="mb-2">
                <Input.TextArea
                  name="message"
                  autoSize={{ minRows: 3, maxRows: 5 }}
                  placeholder="Apa yang ingin Anda tanyakan tentang produk ini?"
                />
              </Form.Item>
              <Form.Item className="mb-1">
                <Button type="dark">Kirim</Button>
              </Form.Item>
            </Form>
          }
        />
      </section>

      <CommentContainer
        body={MESSAGE}
        username="Okky Suardhana"
        image={`https://i.pravatar.cc/100?u=${Math.random()}`}
        content="Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
      >
        <CommentContainer
          body={MESSAGE}
          isAdmin="admin"
          username="Komang Jimb"
          image={`https://i.pravatar.cc/100?u=${Math.random()}`}
          content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        />
        <CommentContainer
          body={REPLY}
          username="Dwi Agung"
          image={`https://i.pravatar.cc/100?u=${Math.random()}`}
        />
      </CommentContainer>

      <CommentContainer
        body={MESSAGE}
        username="Dwi Agung"
        image={`https://i.pravatar.cc/100?u=${Math.random()}`}
        content="Cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
      >
        <CommentContainer
          body={MESSAGE}
          isAdmin="admin"
          username="Komang Jimb"
          image={`https://i.pravatar.cc/100?u=${Math.random()}`}
          content="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        />
        <CommentContainer
          body={REPLY}
          username="Made Darma"
          image={`https://i.pravatar.cc/100?u=${Math.random()}`}
        />
      </CommentContainer>

      <hr className="mt-5 mb-4" />

      <h4>Lainnya</h4>

      <AnimatePresence>
        <Slider {...otherProductSettings} className="other-product-slider">
          {[...Array(10)].map((_, i) => (
            <Row key={productLists[i].name} gutter={[16, 16]} className="h-100">
              <Col className="h-100">
                <CardProduct product={productLists[i]} key={productLists[i].name} />
              </Col>
            </Row>
          ))}
        </Slider>
      </AnimatePresence>

      <br />
      <br />

      <Modal
        centered
        width={350}
        footer={null}
        title={<span className="text-center w-100 d-block fw-500">Bagikan</span>}
        visible={showShare}
        onOk={() => setShowShare(false)}
        onCancel={() => setShowShare(false)}
        closeIcon={<i className="far fa-times" />}
      >
        <CardShare link="google.com" />
      </Modal>

      <Modal
        centered
        zIndex={1030}
        footer={null}
        title={<span className="text-center w-100 d-block fw-500">Informasi Pengiriman</span>}
        visible={showDelivery}
        onOk={() => setShowDelivery(false)}
        onCancel={() => setShowDelivery(false)}
        closeIcon={<i className="far fa-times" />}
      >
        <ul>
          <li className="mb-3">
            <b>Badung</b> <span className="float-end fw-500">Rp{formatNumber(800000)}</span>
          </li>
          <li className="mb-3">
            <b>Bangli</b> <span className="float-end fw-500">Rp{formatNumber(700000)}</span>
          </li>
          <li className="mb-3">
            <b>Buleleng</b> <span className="float-end fw-500">Rp{formatNumber(950000)}</span>
          </li>
          <li className="mb-3">
            <b>Gianyar</b> <span className="float-end fw-500">Rp{formatNumber(500000)}</span>
          </li>
          <li className="mb-3">
            <b>Jembrana</b> <span className="float-end fw-500">Rp{formatNumber(600000)}</span>
          </li>
          <li className="mb-3">
            <b>Karangasem</b> <span className="float-end fw-500">Rp{formatNumber(650000)}</span>
          </li>
          <li className="mb-3">
            <b>Klungkung</b> <span className="float-end fw-500">Rp{formatNumber(300000)}</span>
          </li>
          <li className="mb-3">
            <b>Tabanan</b> <span className="float-end fw-500">Rp{formatNumber(470000)}</span>
          </li>
          <li>
            <b>Kota Denpasar</b>
            <span className="float-end fw-500">Rp{formatNumber(200000)}</span>
          </li>
        </ul>
      </Modal>
    </Container>
  );
};

export default DetailPproduct;
